<template>
    <div class="position-relative">

        <div class="content-wrapper">


            <div class="row mb-5">
                <div class="col-sm-12" :class="!this.showAdverts ? 'col-md-12': 'col-md-6'" v-show="this.showHiring">
                    <div class="panel">
                        <a href="/hiring" class="panel-title">{{ $t('new_candidates') }} <div class="btn btn-primary btn-sm badge-counter">{{ hiringDataTotal }}</div></a>
                        <a href="/hiring?new" class="btn btn-primary btn-sm btn-circle btn-circle-sm float-right"><i class="custom-icon custom-icon-plus custom-icon-button-inline"></i></a>
                    </div>
                    <div class="datatable-simple" :class="{'loading-opacity': hiringPreloader}">

                        <a v-if="hiringData" :href="'/hiring/?profile='+data.id" v-for="(data, index) in hiringData" class="row" :class="index == 0 ? 'font-weight-bold' : ''">
                            <div class="col-4 col-md-3">
                                <span class="text-muted ml-2">{{ formatDate(data.created_at) }}</span>
                            </div>
                            <div class="col-3 col-md-3">
                                {{ data.name+' '+data.surname }}
                            </div>
                            <div v-if="jobData.length && careerData.lenght" class="col-5 col-md-5">
                            </div>
                        </a>
                        <div v-if="!hiringData.length" class="text-center pt-5 pb-5">
                            {{ $t('nothing_to_show_here') }}<br>
                            <a href="/hiring?new" class="btn btn-primary mt-3">{{ $t('add') }}</a>
                        </div>
                        <div v-else-if="hiringDataTotal > 5" class="col-sm-12 text-center mt-3 mb-3">
                            <button class="btn btn-primary" onclick="window.location='/hiring'">{{ $t('display_all') }}</button>
                        </div>

                    </div>
                </div>
                <div class="col-sm-12 " :class="!this.showHiring ? 'col-md-12': 'col-md-6'" v-show="this.showAdverts">

                    <div v-if="countCreatedResponse < 3" class="root-preloader position-absolute overlay-loader-wrapper">
                        <div class="spinner-bounce d-flex align-items-center dashboard-preloader justify-content-center">
                            <span class="bounce1 mr-1"/>
                            <span class="bounce2 mr-1"/>
                            <span class="bounce3 mr-1"/>
                            <span class="bounce4"/>
                        </div>
                    </div>
                    
                    <div class="panel">
                        <a href="/hiring" class="panel-title">{{ $t('scheduled_interviews') }} <div class="btn btn-primary btn-sm badge-counter">{{ interviewDataTotal }}</div></a>
                        <a href="/hiring?timeline=3" class="btn btn-primary btn-sm btn-circle btn-circle-sm float-right"><i class="custom-icon custom-icon-plus custom-icon-button-inline"></i></a>
                    </div>
                    <div class="datatable-simple" :class="{'loading-opacity': interviewPreloader}">

                        <a v-if="interviewData" :href="'/hiring/?profile='+data.id" v-for="(data, index) in interviewData" class="row" :class="index == 0 ? 'font-weight-bold' : ''">
                            <div class="col-md-3">
                                <span class="text-muted ml-2">
                                    {{ data.event_date && formatDate(data.event_date) ? formatDate(data.event_date) : $t('no_date') }}
                                </span>
                            </div>
                            <div class="col-md-4">
                                {{ data.name+' '+data.surname }}
                            </div>
                            <div v-if="jobData.length && careerData.lenght" class="col-5 col-md-5">

                                <button v-if="data.event_date && formatDate(data.event_date)" class="btn btn-primary btn-sm btn-circle btn-circle-xs pb-2" @click.prevent="generateCalendar(data.id, data.timeline_state, data.event_date, data.name+' '+data.surname, data.phone, data.job, 'hiring')" style="transform: scale(0.75);right: 0;margin-top: -5px;position: absolute;"><app-icon :name="'calendar'" width="15" height="15" class="ml-1"/>+</button>
                            </div>
                        </a>
                        <div v-if="!interviewData.length" class="text-center pt-1 pb-5">
                            <b>{{ $t('nothing_to_show_here_interview_schedule') }}</b><br>
                            {{ $t('nothing_to_show_here_interview') }}<br>
                            <button class="btn btn-primary mt-3" onclick="window.location='/hiring?timeline=3'">{{ $t('continue') }}</button>
                        </div>
                        <div v-else-if="interviewDataTotal > 5" class="col-sm-12 text-center mt-3 mb-3">
                            <button class="btn btn-primary" onclick="window.location='/hiring?timeline=4'">{{ $t('display_all') }}</button>
                        </div>
                    </div>
                </div>

            </div>
            <div id="guide-step-hp-1" class="row mb-4">
                <div class="col-sm-12 col-md-4" v-show="this.showOnboarding">
                    <h2><b>{{ $t('all_employees') }}</b></h2><br>
                    <app-overlay-loader v-if="!defaultData && !mainPreloader"/>
                    <div class="col-12 col-md-12 mb-4 mb-md-0">
                        <app-chart v-if="isActiveEmployeeTimelineStats" class="mb-primary"
                                       type="dough-chart"
                                       :height="330"
                                       :labels="employeeTimelineStats.labels"
                                       :data-sets="employeeTimelineStats.dataSet"/>
                            <div class="chart-data-list">
                                <div class="row">
                                    <div class="col-12"
                                         v-for="(item, index) in employeeTimelineStats.chartElement" :key="index">
                                        <div class="data-group-item" :style="item.color">
                                            <span class="square" :style="item.background_color"/>
                                            {{item.key}}
                                            <span class="value">{{item.value}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 mb-4 mb-md-0" :class="!this.showHiring ? 'col-md-4 col-lg-4 col-xl-4': 'col-md-4 col-lg-4 col-xl-4'" v-show="this.showOnboarding">
                    <h4>
                        <b>{{ $t('new_boarding') }}</b>
                        <div class="btn btn-primary btn-sm badge-counter">{{ employeeBoardingDataTotal }}</div>
                    </h4>
                    <div class="w-100 text-center">
                        <img src="/images/illustration_people.svg" style="width: 65%;" class="illustration-svg">
                    </div>

                    <div class="datatable-simple" :class="{'loading-opacity': employeeBoardingPreloader}">

                        <a v-if="employeeBoardingData" :href="'/onboarding/?profile='+data.id" v-for="(data, index) in employeeBoardingData" class="row" :class="index == 0 ? 'font-weight-bold' : ''">
                            <div class="col-md-4">
                                <span class="text-muted ml-2">
                                    {{ data.event_date ? formatDate(data.event_date) : $t('no_date') }}
                                </span>
                            </div>
                            <div class="col-md-7">
                                {{ data.name+' '+data.surname }}<br>
                                {{ getJobName(data.job) }}
                            </div>
                            <div class="col-md-1">
                                <button v-if="data.event_date" class="btn btn-primary btn-sm btn-circle btn-circle-xs pb-2" @click.prevent="generateCalendar(data.id, data.timeline_state, data.event_date, data.name+' '+data.surname, data.phone, data.job, 'onboarding')" style="transform: scale(0.75);right: 0;margin-top: -5px;position: absolute;"><app-icon :name="'calendar'" width="15" height="15" class="ml-1"/>+</button>
                            </div>
                        </a>
                        <div v-if="!employeeBoardingData.length" class="text-center pt-1 pb-5">
                            <b>{{ $t('nothing_to_show_here_onboarding_schedule') }}</b><br>
                            {{ $t('nothing_to_show_here_onboarding') }}<br>
                            <button class="btn btn-primary mt-3" onclick="window.location='/hiring?timeline=6'">{{ $t('plan_boarding') }}</button>
                        </div>
                        <div v-else-if="employeeBoardingDataTotal > 5" class="col-sm-12 text-center mt-3 mb-3">
                            <button class="btn btn-primary" onclick="window.location='/onboarding'">{{ $t('display_all') }}</button>
                        </div>

                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mb-4 mb-md-0" v-show="this.showOnboarding">
                    <h4 class="guide-step-global-3">
                        <b>{{ $t('birthdays') }}</b>
                        <div class="btn btn-primary btn-sm badge-counter">{{ birthdayDataTotal }}</div>
                    </h4>
                    <div class="w-100 text-center">
                        <img src="/images/illustration_gift.svg" style="width: 60%;" class="illustration-svg">
                    </div>

                    <div class="datatable-simple" :class="{'loading-opacity': checklistPreloader}">

                        <a v-if="birthdayData" :href="'/onboarding?profile='+data.id" v-for="(data, index) in birthdayData" class="row" :class="index == 0 ? 'font-weight-bold' : ''">
                            <div class="col-md-3">
                                <span class="text-muted ml-2">
                                    {{ data.birthdate_day ? formatDateSimple(data.birthdate_day) : $t('no_date') }}
                                </span>
                            </div>
                            <div class="col-md-8">
                                <div class=" ml-2">
                                    {{ data.name+' '+data.surname }}<br>
                                    {{ $t('celebrates') }} {{ data.birthdate_years }} {{ $t('years_plural') }}<br>
                                </div>
                            </div>

                        </a>
                        <div v-if="!birthdayData.length" class="text-center pt-1 pb-5">
                            <b>{{ $t('nothing_to_show_here') }}</b><br>
                            {{ $t('nothing_to_show_here') }}<br>
                        </div>

                    </div>
                </div>


            </div>
            


            <div class="row mt-5">
                
                <div class="col-sm-12 col-md-4 mt-3"  v-show="this.showOnboarding">
                        <div class="col-12">
                                <h4 class="mt-1"><b>Tipy</b></h4>
                                <div class="overlay-locked pt-5 mt-3">
                                    <app-icon :name="'comment'" width="40" height="40"/><br>
                                    <div class="offset-md-2 col-md-8">
                                        <h5><b>Sbírejte zpětnou vazbu</b></h5><br>
                                        Pravidelná zpětná vazba zvýší spokojenost zaměstnanců a pomůže udržet nováčky v zaměstnání.<br>
                                        <button class="btn btn-primary mt-3" onclick="window.location='/onboarding/feedback'">{{ $t('continue') }}</button>
                                    </div>

                                </div>
                                <div class="content-locked locked-group">
                                <app-chart v-if="academydashboard.studentOverview" type="horizontal-line-chart"
                                           :height="380"
                                           :labels="academydashboard.studentOverview.labels"
                                           :data-sets="academydashboard.studentOverview.dataSet"/>
                                </div>

                        </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mb-4 mb-md-0 mt-3" v-show="this.showOnboarding">
                    <h4 class="guide-step-global-3">
                        <b>{{ $t('tasks_internal') }}</b>
                        <div class="btn btn-primary btn-sm badge-counter">{{ checklistDataTotal }}</div>
                    </h4>
                    <div class="w-100 text-center">
                        <img src="/images/illustration_done.svg" style="width: 60%;" class="illustration-svg">
                    </div>

                    <div class="datatable-simple" :class="{'loading-opacity': checklistPreloader}">

                        <a v-if="checklistData" :href="'/onboarding?profile='+data.candidate_id" v-for="(data, index) in checklistData" class="row" :class="index == 0 ? 'font-weight-bold' : ''">
                            <div class="col-md-3">
                                <span class="text-muted ml-2">
                                    {{ data.deadline ? formatDateSimple(data.deadline) : $t('no_date') }}
                                </span>
                            </div>
                            <div class="col-md-8">
                                <div class=" ml-2">
                                    {{ data.candidate.name }} {{ data.candidate.surname }}<br>
                                    {{ data.name }}<br>
                                </div>
                            </div>

                        </a>
                        <div v-if="!checklistData.length" class="text-center pt-1 pb-5">
                            <b>{{ $t('nothing_to_show_here_tasks') }}</b><br>
                            {{ $t('nothing_to_show_here_onboarding_checklist') }}<br>
                            <button class="btn btn-primary mt-3" onclick="window.location='/onboarding'">{{ $t('continue') }}</button>
                        </div>
                        <div v-else-if="checklistDataTotal > 5 || checklistDataTotal == '99+'" class="col-sm-12 text-center mt-3 mb-3">
                            <button class="btn btn-primary" onclick="window.location='/onboarding/checklist'">{{ $t('display_all') }}</button>
                        </div>

                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mb-4 mb-md-0 mt-3" v-show="this.showOnboarding">
                    <h4 class="guide-step-global-3">
                        <b>{{ $t('anniversaries') }}</b>
                        <div class="btn btn-primary btn-sm badge-counter">{{ anniversaryDataTotal }}</div>
                    </h4>
                    <div class="w-100 text-center">
                        <img src="/images/illustration_welcome.svg" style="width: 60%;" class="illustration-svg">
                    </div>

                    <div class="datatable-simple" :class="{'loading-opacity': checklistPreloader}">

                        <a v-if="anniversaryData" :href="'/onboarding?profile='+data.id" v-for="(data, index) in anniversaryData" class="row" :class="index == 0 ? 'font-weight-bold' : ''">
                            <div class="col-md-3">
                                <span class="text-muted ml-2">
                                    {{ data.event_date_day ? formatDateSimple(data.event_date_day) : $t('no_date') }}
                                </span>
                            </div>
                            <div class="col-md-8">
                                <div class=" ml-2">
                                    {{ data.name+' '+data.surname }}<br>
                                    {{ $t('celebrates') }} {{ data.event_date_years }} {{ $t('years_plural') }}<br>
                                </div>
                            </div>

                        </a>
                        <div v-if="!anniversaryData.length" class="text-center pt-1 pb-5">
                            <b>{{ $t('nothing_to_show_here') }}</b><br>
                            {{ $t('nothing_to_show_here') }}<br>
                        </div>

                    </div>
                </div>
                

                <!-- 
                <div class="col-sm-12 col-md-4" v-show="this.showHiring">
                        <h2><b>{{ $t('hiring_state') }}</b></h2><br>
                        <app-overlay-loader v-if="!defaultData && !mainPreloader"/>
                        <div class="col-12 col-md-12 mb-4 mb-md-0">
                            <app-chart v-if="isActiveHiringTimelineStats" class="mb-primary"
                                        type="dough-chart"
                                        :height="330"
                                        :labels="hiringTimelineStats.labels"
                                        :data-sets="hiringTimelineStats.dataSet"/>
                                <div class="chart-data-list">
                                    <div class="row">
                                        <div class="col-12"
                                            v-for="(item, index) in hiringTimelineStats.chartElement" :key="index">
                                            <div class="data-group-item" :style="item.color">
                                                <span class="square" :style="item.background_color"/>
                                                {{item.key}}
                                                <span class="value">{{item.value}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                -->




<div class="col-sm-12 row mt-5" v-show="this.showHiring">
            </div>

<div class="row mb-5 col-sm-12">
                <div v-if="this.showForms" class="modal-contentbox-row pr-0 w-100 pb-5 p-3">
                    <div class="panel mb-4">
                        <a href="#" class="panel-title">Testy a kvízy</a>
                    </div>

                        <div v-if="this.atendeeOptions && this.graduateOptionsUnique">
                            <div class="col-12 col-md-6 p-0 float-left form-group row align-items-center mb-2 d-none">
                                <label for="inputs_finished" class="col-sm-12">
                                    {{ $t('already_graduated') }} <div v-if="graduateOptionsUnique.data" class="btn btn-primary btn-sm badge-counter">{{ graduateOptionsUnique.data.length }}</div>
                                </label>
                                <div class="mb-0 col-sm-12 mb-5">
                                    <app-employee-list :employees="this.graduateOptionsUnique ? this.graduateOptionsUnique : ''" class="loading-hidden"></app-employee-list>
                                </div>

                            </div>
                            <div class="col-12 col-md-6 p-0 float-left form-group row align-items-center mb-2 d-none">
                                <label for="inputs_finished" class="col-sm-12">
                                    Ještě se zůčastní <div v-if="atendeeOptions.data" class="btn btn-primary btn-sm badge-counter">{{ atendeeOptions.data.length }}</div>
                                </label>
                                <div class="mb-0 col-sm-12 mb-5">
                                    <app-employee-list :employees="this.atendeeOptions ? this.atendeeOptions : ''" class="loading-hidden"></app-employee-list>
                                </div>

                            </div>
                        </div>


                        <div v-if="graduateOptions.total" style="float:left">
                            <div class="col-12 col-md-6 p-4 float-left form-group row align-items-center mb-0">
                                <app-chart v-if="isActiveAtendeeStats" class="mb-primary mt-4"
                                               type="dough-chart"
                                               :width="320"
                                               :height="160"
                                               :labels="graduateStats.labels"
                                               :data-sets="graduateStats.dataSet"/>
                            </div>
                            <div class="col-12 col-md-6 pt-5 mb-5 pl-1 float-left form-group row align-items-center mb-0">
                                <div class="chart-data-list">
                                    <div class="row">
                                        <label for="inputs_finished" class="col-sm-12 mb-3">
                                            {{ $t('graduates_answers') }}
                                        </label>
                                        <div class="col-12" v-for="(item, index) in graduateStats.chartElement" :key="index">
                                            <div class="data-group-item" :style="item.color">
                                                    <span class="square" :style="item.background_color"/>
                                                        {{item.key}}
                                                    <span class="value">{{item.value}}</span>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-4 pl-0">
                                            <label v-if="graduateOptions.totalInLast30Days.change.includes('-') && graduateOptions.totalInLast30Days.total > 0 && graduateOptions.totalBefore30Days.total > 0" for="" class="col-sm-12">
                                                {{ $t('in_the_last_30_days') }} <span style="color:rgb(188, 51, 93)">{{ $t('in_the_last_30_days_about') }} {{ graduateOptions.totalInLast30Days.change.replace('-', '') }} {{ $t('worst_answers_in_comparsion') }} &#9660; </span>
                                            </label>
                                            <label v-else-if="graduateOptions.totalInLast30Days.total > 0 && graduateOptions.totalBefore30Days.total > 0" for="" class="col-sm-12">
                                                {{ $t('in_the_last_30_days') }} <span style="color:rgb(86, 129, 139)">{{ $t('in_the_last_30_days_about') }} {{ graduateOptions.totalInLast30Days.change }} {{ $t('better_answers_in_comparsion') }} &#9650; </span>
                                            </label>
                                            <label v-else-if="graduateOptions.totalInLast30Days.total == 0 && graduateOptions.totalBefore30Days.total > 0" for="" class="col-sm-12">
                                                {{ $t('in_the_last_30_days') }} {{ $t('in_the_last_30_days_no_answers') }}
                                            </label>
                                            <label v-else-if="graduateOptions.totalInLast30Days.total > 0 && graduateOptions.totalBefore30Days.total == 0" for="" class="col-sm-12">
                                                {{ $t('in_the_last_30_days_first_answers') }}
                                            </label>
                                            <label v-else-if="graduateOptions.totalInLast30Days.total == 0 && graduateOptions.totalBefore30Days.total == 0" for="" class="col-sm-12">
                                                {{ $t('no_answers_yet') }}
                                            </label>
                                            <br>
                                            <div class="col-sm-12 text-muted small">{{ $t('current_success') }} {{ graduateOptions.totalInLast30Days.correctRatio }} ({{ graduateOptions.totalInLast30Days.total }} {{ $t('answers_plural') }})<br>{{ $t('success_30_days_ago') }} {{ graduateOptions.totalBefore30Days.correctRatio }}  ({{ graduateOptions.totalBefore30Days.total }} {{ $t('answers_plural') }})</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-12 p-4 float-left form-group row align-items-center mb-0 card card-outline d-block text-muted">
                                <div class="col-12 col-md-6 text-center">
                                    <app-icon :name="'clock'" width="25" height="25" class="mr-2"/>
                                    <b>{{ this.graduateOptions.totalDeadlines.ontimeRatio }}</b>
                                    {{ $t('answers_form_ontime') }}
                                    
                                </div>
                                <div class="col-12 col-md-6 text-center">
                                    
                                    
                                    <span v-if="this.graduateOptions.totalDeadlines.average == 1">
                                        <app-icon :name="'check'" width="25" height="25" class="mr-2"/>
                                        <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t('day_before_deadline') }} {{ $t('average_delay') }}
                                    </span>
                                    <span v-else-if="this.graduateOptions.totalDeadlines.average >= 0 && this.graduateOptions.totalDeadlines.average < 5">
                                        <app-icon :name="'check'" width="25" height="25" class="mr-2"/>
                                        <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t('days_before_deadline') }} {{ $t('average_delay') }}
                                    </span> 
                                    <span v-else-if="this.graduateOptions.totalDeadlines.average >= 0">
                                        <app-icon :name="'check'" width="25" height="25" class="mr-2"/>
                                        <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t('days_plural_before_deadline') }} {{ $t('average_delay') }}
                                    </span>
                                    <span v-else >
                                        <app-icon :name="'x'" width="25" height="25" class="mr-2"/>
                                        <b>{{ (this.graduateOptions.totalDeadlines.average)*(-1) }}</b> {{ $t('day_after_deadline') }} {{ $t('average_delay') }}
                                    </span>
                                    
                                </div>
                            </div>
                            <div class="col-12 col-md-12 p-0 float-left form-group row align-items-center mb-0">
                                <div class="col-12 pr-0">

                                        <app-result-list :results="this.graduateOptions.data ? this.graduateOptions.data : ''" :form-name="false" class="loading-hidden"></app-result-list>

                                </div>
                            </div>


                        </div>
                        <div v-else class="text-center mt-5">
                            Zde se objeví výsledky hned jak nasbíráte nějaké odpovědi
                        </div>

                </div>
            </div>

<div v-if="isActiveEmployeeOverviewStats" class="w-100 row mt-5 ml-3 mr-3 card card-outline d-block">

                <div class="col-12 col-md-4 text-center" style="min-height: 280px;" v-show="this.showOnboarding">
                    <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                        <h4><b>{{ $t('average_age') }}</b></h4>
                    </div>
                        <div v-for="(value, name, index) in employeeOverviewStats.averageAge">
                            <h5><b>{{ value }} let</b></h5> 
                            <span class="text-muted text-lowercase">{{ $t(name+'_plural') }}</span><br><br>
                        </div>
                        
                </div>
                <div class="col-12 col-md-4 text-center" style="min-height: 280px;" v-show="this.showOnboarding">
                    <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                        <h4><b>{{ $t('equality') }}</b></h4>
                    </div>
                        <div v-for="(value, name, index) in employeeOverviewStats.averageSalary">
                            <h5><b>{{ value }} Kč</b></h5> 
                            <span class="text-muted text-lowercase">{{ $t('average_salary') }} {{ $t(name+'_plural') }}</span><br><br>
                        </div>
                </div>
                <div class="col-12 col-md-4 text-center" style="min-height: 280px;" v-show="this.showOnboarding">
                    <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                        <h4><b>{{ $t('diversity') }}</b></h4>
                    </div>
                        <div v-for="(value, name, index) in employeeOverviewStats.totals">
                            <h5><b>{{ value }}</b></h5> 
                            <span class="text-muted text-lowercase">{{ $t(name+'_plural') }}</span><br><br>
                        </div>
                </div>

</div>
<div class="w-100 row mt-5 ml-3 mr-3 card card-outline d-block">

                <div class="col-12 col-md-8" style="min-height: 550px;" v-show="this.showOnboarding">

                    <div>
                        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                            <h4><b>{{ $t('growth') }}</b></h4>
                            <ul class="nav tab-filter-menu justify-content-flex-end">
                                <li class="nav-item"
                                    v-for="(item, index) in employeeCareerStats.chartFilterOptions"
                                    :key="index">
                                    <a href="#"
                                       class="nav-link py-0"
                                       :class="[careersFilter == item.id ? 'active' : index === 0 && careersFilter === '' ? 'active': '']"
                                       @click.prevent="careersFilterValue(item.id)">
                                        {{ $t(item.value) }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div v-if="isActiveEmployeeCareerDetailStats" class="card-body">
                            <app-chart class="mb-primary"
                                       type="line-chart"
                                       :height="230"
                                       :labels="employeeCareerDetailStats.labels"
                                       :data-sets="employeeCareerDetailStats.chartData"/>
                            <div class="chart-data-list d-flex flex-wrap justify-content-center">
                                <div class="data-group-item" style="color: #c42d5e">
                                    <span class="square" style="background-color: #c42d5e"/>
                                    <b>{{ $t('all_employees') }}</b>
                                    <span class="value">{{ employeeCareerDetailStats.candidateCount }}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="this.employeeCareerStats.labels" class="col-12 col-md-4" v-show="this.showOnboarding">
                    <div>
                        <div class="card-body"  >
                            <div class="row flex-row">
                                <div class="col-sm-12 col-md-6 mt-2 text-right">
                                    Pracovní pozice:
                                </div>
                                <div class="col-sm-12 col-md-6">

                                    <app-input  class="jobs"
                                           type="select"
                                           :title="$t('job')"
                                           v-model="candidateCareer"
                                           :list="jobData"
                                            @change="careersJobFilterValue(candidateCareer)"
                                           />
                                </div>
                            </div>

                            <br><br>
                            <app-overlay-loader v-if="!isActiveEmployeeCareerStats && !mainPreloader"/>

                            <h1 v-if="employeeCareerStats.labels.length === 0" class="w-100 text-center"><strong>0</strong></h1>
                            <app-chart v-if="isActiveEmployeeCareerStats && employeeCareerStats.labels"
                                       class="mb-primary"
                                       type="pie-chart"
                                       :height="230"
                                       :labels="employeeCareerStats.labels"
                                       :data-sets="employeeCareerStats.dataSet"/>
                            <div v-if="isActiveEmployeeCareerStats" class="chart-data-list">
                                
                                <div class="row">
                                    <div class="col-12"
                                         v-for="(item, index) in employeeCareerStats.chartElement">
                                        <div class="data-group-item" :style="item.color">
                                            <span class="square" :style="item.background_color"/>
                                            {{item.key}}
                                            <span class="value">{{item.value}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>


                </div>










        </div>









        <div class="w-100 row mt-5 ml-3 mr-3 card card-outline d-block">

                <div class="col-12 col-md-8" style="min-height: 550px;" v-show="this.showHiring">

                    <div>
                        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                            <h4><b>{{ $t('best_sources') }}</b></h4>
                            <ul class="nav tab-filter-menu justify-content-flex-end">
                                <li class="nav-item"
                                    v-for="(item, index) in advertSourcesStats.chartFilterOptions"
                                    :key="index">
                                    <a href="#"
                                       class="nav-link py-0"
                                       :class="[sourcesFilter == item.id ? 'active' : index === 0 && sourcesFilter === '' ? 'active': '']"
                                       @click.prevent="sourcesFilterValue(item.id)">
                                        {{ $t(item.value) }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div v-if="isActiveAdvertSourcesDetailStats" class="card-body">
                            <app-chart class="mb-primary"
                                       type="line-chart"
                                       :height="230"
                                       :labels="advertSourcesDetailStats.labels"
                                       :data-sets="advertSourcesDetailStats.chartData"/>
                            <div class="chart-data-list d-flex flex-wrap justify-content-center">
                                <div class="data-group-item" style="color: #c42d5e">
                                    <span class="square" style="background-color: #c42d5e"/>
                                    <b>Noví uchazeči</b>
                                    <span class="value">{{ advertSourcesDetailStats.candidateCount }}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="this.advertSourcesStats.labels" class="col-12 col-md-4" v-show="this.showHiring">
                    <div>
                        <div class="card-body"  >
                            <div class="row flex-row">
                                <div class="col-sm-12 col-md-6 mt-2 text-right">
                                    Pracovní pozice:
                                </div>
                                <div class="col-sm-12 col-md-6">

                                    <app-input  class="jobs"
                                           type="select"
                                           :title="$t('job')"
                                           v-model="candidateSource"
                                           :list="jobData"
                                            @change="sourcesJobFilterValue(candidateSource)"
                                           />
                                </div>
                            </div>

                            <br><br>
                            <app-overlay-loader v-if="!isActiveAdvertSourcesStats && !mainPreloader"/>

                            <h1 v-if="advertSourcesStats.labels.length === 0" class="w-100 text-center"><strong>0</strong></h1>
                            <app-chart v-if="isActiveAdvertSourcesStats"
                                       class="mb-primary"
                                       type="pie-chart"
                                       :height="230"
                                       :labels="advertSourcesStats.labels"
                                       :data-sets="advertSourcesStats.dataSet"/>
                            <div v-if="isActiveAdvertSourcesStats" class="chart-data-list">
                                <div class="row">
                                    <div class="col-12"
                                         v-for="(item, index) in advertSourcesStats.chartElement">
                                        <div class="data-group-item" :style="item.color">
                                            <span class="square" :style="item.background_color"/>
                                            {{item.key}}
                                            <span class="value">{{item.value}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>


                </div>










        </div>
    </div>





            <div class="row mt-3 mb-3">


                <div class="w-100 text-center mt-5">
                    <div class="col-sm-12 col-md-6 offset-md-3 text-center mt-5">
                        <h4><b>{{ $t('we_are_happy_that_you_re_with_us') }}</b></h4>
                        <br>
                        <b>{{ $t('your_feedback_helps_us') }}</b> {{ $t('your_feedback_helps_us_text') }}<br><br>
                        <img src="/images/illustration-boats.svg" class="mt-3 mb-3 illustration-svg" style="width: 80%; max-width: 250px;"><br>
                        <a class="btn btn-primary" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdQdHBkAaJVDSU17GXr2BBUMxN13KxJMLMsk3Z17PdD4cuIJQ/viewform">{{ $t('open_feedback_form') }}</a>
                    </div>



                </div>



            <div class="col-sm-12 w-100 row mt-5 text-muted">
                <div class="col-sm-12 col-md-8">
                    © {{ showYear() }} {{ $t('copyright_info') }} <a href="" class="ml-2 mr-2" @click.prevent="openChat()"><app-icon :name="'message-square'" width="18" height="18"/> {{ $t('contact_support') }}</a>

                    <span class="footer-contacts ml-1" style="display:none;">
                        <a :href="'mailto:'+$t('contacts_info_email')">– {{ $t('contacts_info_email') }}</a>
                        <span class="ml-2">{{ $t('contacts_info_phone') }}</span>
                    </span>
                </div>

            </div>

        </div>

    </div>

    </div>
</template>


<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
    import {UserMixin} from "../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import {DashboardPreloader} from "./Mixins/DashboardPreloader";
    import * as actions from '../../../../Config/ApiUrl';
    import {numberFormatter} from "../../../../Helpers/Helpers";
    import AppFunction from "../../../../../core/helpers/app/AppFunction";

    export default {
        name: "MainDashboard",
        mixins: [FormMixin,UserMixin,DashboardPreloader],
        data() {
            return {
                trialMode: false,
                daysRemaining: '',

                /* Latest */
                careerData: [],
                careerDataTotal: '',
                hiringData: [],
                hiringDataTotal: '',
                jobData: [],
                careerPreloader: true,
                hiringPreloader: true,
                candidatePreloader: true,
                showAdverts: false,
                showHiring: false,
                showOnboarding: false,

                /* Candidates */
                hiringTimelineStats: [],
                employeeTimelineStats: [],
                isActiveHiringTimelineStats: false,
                interviewPreloader: true,
                interviewData: [],
                interviewDataTotal: '',
                advertStats: [],
                isActiveAdvertStats: false,
                advertSourcesStats: [],
                isActiveAdvertSourcesStats: false,
                sourcesFilter: 'total',
                candidateSource: '0',
                advertSourcesDetailStats: [],
                isActiveAdvertSourcesDetailStats: false,
                timelineStatesLists: [
                    {id: '1', value: 'Noví uchazeči'},
                    {id: '2', value: 'Předvýběr'},
                    {id: '3', value: '1. kolo'},
                    {id: '4', value: '2. kolo'},
                    {id: '5', value: '3. kolo'},
                    {id: '6', value: 'K přijetí'},
                ],

                /* Employees */
                employeeBoardingPreloader: true,
                checklistPreloader: true,
                isActiveEmployeeTimelineStats: false,
                isActiveEmployeeCareerStats: false,
                checklistData: [],
                checklistDataTotal: '',
                birthdayData: [],
                birthdayDataTotal: '',
                anniversaryData: [],
                anniversaryDataTotal: '',
                employeeBoardingData: [],
                employeeBoardingDataTotal: '',
                employeeCareerStats: [],
                employeeCareerDetailStats: [],
                isActiveEmployeeCareerDetailStats: false,
                employeeOverviewStats: [],
                isActiveEmployeeOverviewStats: false,
                careersFilter: 'this_year',
                candidateCareer: '0',
                atendeeOptions: {
                    total: 0,
                },
                graduateOptions: {
                    data: [],
                    total: 0,
                },
                graduateOptionsUnique: {
                    data: [],
                    total: 0,
                },
                
                

                /* Loader section and active/inactive section */
                mainPreloader: false,

                isActivedDefaultData: false,
                isActiveStudentOverview: false,
                isActivetimelineStats: false,
                isActiveInstructorStudentOverview: false,
                /* end */

                hospital: {},
                isActivePatientStatistics: false,

                /* Loader section and active/inactive section */
                mainPreloader: true,

                isActivedDefaultiInfo: false,
                isActiveBusinessOverview: false,
                isActiveContactOverview: false,
                isActiveTeamOverview: false,
                /* end */

                e_commerceDashboard: {},
                businessFilter: 'this_week',
                contactFilter: 'this_week',

                value: 'by_school',


                checklistsource: '1',


                checklistLists: [
                    {id: '1', value: 'Před nástupem'},
                    {id: '2', value: '1. den'},
                    {id: '3', value: '1. týden'},
                ],

                showForms: false,
                isActiveAtendeeStats: false,

                academydashboard: {},
                availableCourses: {
                    name: 'Available Courses',
                    url: actions.AVAILABLE_COURSE_LIST,
                    datatableWrapper: false,
                    tableShadow: false,
                    showHeader: false,
                    managePagination: false,
                    columns: [
                        {
                            title: this.$t('course'),
                            type: 'media-object',
                            key: 'image',
                            mediaTitleKey: 'name',
                            mediaSubtitleKey: 'instructor-name',
                            default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                            modifier: (value, row) => {
                                return value; // imag url
                            },
                            isVisible: true
                        },
                        {
                            title: this.$t('status'),
                            type: 'custom-class',
                            key: 'status',
                            isVisible: true,
                            modifier: (value) => {
                                if (value === 'Basic') return "badge badge-sm badge-pill badge-success";
                                else if (value === 'Special') return "badge badge-sm badge-pill badge-warning";
                                return "badge badge-sm badge-pill badge-danger";
                            }
                        }
                    ],
                    showFilter: false,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 4,
                    orderBy: 'desc',
                    showAction: false,
                    actions: [],
                },
            }
        },

        created() {
            /**
             * Latest
             * */
            this.getCareerData();
            this.getHiringData();
            this.getJobs();
            this.getBirthdayData();
            this.getAnniversaryData();

            /**
             * Candidates
             * */
            this.getHiringTimelineStats();
            this.getAdvertResponsesStats();
            this.getAdvertSourcesStats();
            this.getAdvertSourcesDetailStats();
            this.getInterviewData();
            this.getEmployeeBoardingData();
            this.getChecklistData();
            this.getTimelineStateNames();

            /**
             * Employees
             * */
            this.getEmployeeTimelineStats();
            this.getEmployeeCareerStats();
            this.getEmployeeCareerDetailStats();
            this.getEmployeeOverviewStats();

            this.defaultData();
            this.studentOverview();
            this.instructorStudentOverview();

            this.patientStatistics();

            this.teamOverview();
            this.ecommerceDefaultInfo();
            this.businessOverview();
            this.contactOverview();

            
        },
        mounted() {
            this.checkPermissions();

            /**
             * Forms
             * */
            this.getAttendees();
        },
        methods: {
            /**
            * Membership
            */
            checkPermissions() {
                this.showAdverts = true;
                this.showHiring = true;
                this.showOnboarding = true;

                if(!$('#sidebar li[data-href="/hiring"]').length){
                    this.showAdverts = false;
                }
                if(!$('#sidebar li[data-href="/hiring"]').length){
                    this.showHiring = false;
                }
                if(!$('#sidebar li[data-href="/onboarding"]').length){
                    this.showOnboarding = false;
                }
            },
            openPayModal(id) {
              this.payModalActive = true;

              // link to buy a membership
              if (history.pushState && id == 1) {
                  var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?pay=1';
                  window.history.pushState({path:newurl},'',newurl);
              }

            },

            /**
             * Latest
             * */
            getCareerData() {
                let url = actions.DATATABLE_CAREERS_DATA+'?filter_with_status_id=1&per_page=5&page=1&search=&orderBy=desc';

                this.axiosGet(url).then(response => {

                    this.careerData = response.data.data;
                    this.careerDataTotal = response.data.total;

                }).catch(({response}) => {

                }).finally(() => {
                    this.careerPreloader = false;
                });
            },
            getHiringData() {
                let url = actions.DATATABLE_CANDIDATES_DATA+'?filter_with_status=2&filter_with_timeline_state=1&per_page=5&page=1&search=&orderBy=desc';

                this.axiosGet(url).then(response => {

                    this.hiringData = response.data.data;
                    this.hiringDataTotal = response.data.total;

                }).catch(({response}) => {

                }).finally(() => {
                    this.hiringPreloader = false;
                });
            },
            formatDate(date) {
                let addDate = new Date(date);
                let todaysDate = new Date();

                if(addDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
                    return this.$t('today')+' '+moment(date).format('HH:mm');
                } else {
                    let formattedDate = moment(date).format('DD. MM. HH:mm');
                    return formattedDate;
                }

            },
            formatDateSimple(date) {
                let addDate = new Date(date);
                let todaysDate = new Date();
                if(addDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
                    return this.$t('today');
                } else {
                    let formattedDate = moment(date).format('DD. MM.');
                    return formattedDate;
                }
            },
            getJobs() {
                let url = actions.JOBS_DATA;
                this.axiosGet(url).then(response => {

                    const jobOptionsArray = response.data.map(({
                      job: value,
                      ...rest
                    }) => ({
                      value,
                      ...rest
                    }));

                    let all = {id:"0", value:this.$t('all')};
                    jobOptionsArray.unshift(all);

                    this.jobData = jobOptionsArray;

                }).catch(({response}) => {
                }).finally(() => {
                });
            },
            getJobName(value, jobData) {
                let index;
                let a = [value];
                let job_html = '';
                for (index = 0; index < a.length; ++index) {
                    let selected_job = this.jobData.find(o => o.id === a[index]);
                    job_html = selected_job.value;
                    

                }
                return job_html;
            },

            /**
             * Hiring
             * */
            getHiringTimelineStats() {
                let url = actions.TIMELINE_STATS, reqData = {};

                reqData.params = {
                    status: 2,
                };

                this.axiosGet(url, reqData).then(response => {

                    this.hiringTimelineStats = response.data;
                    this.isActivetimelineStats = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveHiringTimelineStats = true;
                    this.countCreatedResponse++;
                });
            },
            getAdvertResponsesStats() {
                let url = actions.CAREER_RESPONSES_STATS, reqData = {};

                reqData.params = {
                    career_status: 1,
                };

                // @todo: filter by deleted:
                // exclude_candidate_status: 4,

                this.axiosGet(url, reqData).then(response => {

                    this.advertStats = response.data;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveAdvertStats = true;
                    this.countCreatedResponse++;
                });
            },
            getAdvertSourcesStats() {
                let url = actions.CAREER_SOURCES_STATS, reqData = {};

                reqData.params = {
                    period: this.sourcesFilter,
                    job: this.sourcesJobFilter,
                };

                this.axiosGet(url, reqData).then(response => {

                    this.advertSourcesStats = response.data;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveAdvertSourcesStats = true;
                    this.countCreatedResponse++;
                });
            },
            sourcesFilterValue(item) {
                this.sourcesFilter = item;
                this.isActiveAdvertSourcesStats = false;
                this.isActiveAdvertSourcesDetailStats = false;
                this.getAdvertSourcesStats();
                this.getAdvertSourcesDetailStats();
            },
            sourcesJobFilterValue(item) {
                this.sourcesJobFilter = item;
                this.isActiveAdvertSourcesStats = false;
                this.isActiveAdvertSourcesDetailStats = false;
                this.getAdvertSourcesStats();
                this.getAdvertSourcesDetailStats();
            },
            getAdvertSourcesDetailStats() {
                let url = actions.CAREER_SOURCES_DETAIL_STATS, reqData = {};

                reqData.params = {
                    period: this.sourcesFilter,
                    job: this.sourcesJobFilter,
                };

                this.axiosGet(url, reqData).then(response => {

                    this.advertSourcesDetailStats = response.data;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveAdvertSourcesDetailStats = true;
                    this.countCreatedResponse++;
                });
            },



            getInterviewData() {
                let url = actions.CANDIDATES_EVENTS_DATA;

                this.axiosGet(url).then(response => {

                    this.interviewData = response.data.data;
                    this.interviewDataTotal = response.data.total;

                }).catch(({response}) => {

                }).finally(() => {
                    this.interviewPreloader = false;
                    this.isActiveHiringTimelineStats = true;
                });
            },
            getEmployeeBoardingData() {
                let url = actions.CANDIDATES_ONBOARDING_EVENTS_DATA;

                this.axiosGet(url).then(response => {

                    this.employeeBoardingData = response.data.data;
                    this.employeeBoardingDataTotal = response.data.total;

                }).catch(({response}) => {

                }).finally(() => {
                    this.employeeBoardingPreloader = false;
                });
            },


            /**
             * Onboarding
             * */
            getEmployeeTimelineStats() {
                let url = actions.TIMELINE_STATS, reqData = {};

                reqData.params = {
                    status: 3,
                };

                this.axiosGet(url, reqData).then(response => {

                    this.employeeTimelineStats = response.data;
                    this.isActivetimelineStats = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveEmployeeTimelineStats = true;
                    this.countCreatedResponse++;
                });
            },
            getEmployeeCareerStats() {
                let url = actions.CAREER_EMPLOYEES_STATS, reqData = {};

                reqData.params = {
                    candidate_status: [3,4],
                    period: this.careersFilter,
                    job: this.careersJobFilter,
                };

                this.axiosGet(url, reqData).then(response => {

                    this.employeeCareerStats = response.data;
                    this.isActivetimelineStats = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveEmployeeCareerStats = true;
                    this.countCreatedResponse++;
                });
            },
            careersFilterValue(item) {
                this.careersFilter = item;
                this.isActiveEmployeeCareerStats = false;
                this.isActiveEmployeeCareerDetailStats = false;
                this.getEmployeeCareerStats();
                this.getEmployeeCareerDetailStats();
            },
            careersJobFilterValue(item) {
                this.careersJobFilter = item;
                this.isActiveEmployeeCareerStats = false;
                this.isActiveEmployeeCareerDetailStats = false;
                this.getEmployeeCareerStats();
                this.getEmployeeCareerDetailStats();
            },
            getEmployeeCareerDetailStats() {
                let url = actions.CAREER_EMPLOYEES_DETAIL_STATS, reqData = {};

                reqData.params = {
                    candidate_status: [3,4],
                    period: this.careersFilter,
                    job: this.careersJobFilter,
                };

                this.axiosGet(url, reqData).then(response => {

                    this.employeeCareerDetailStats = response.data;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveEmployeeCareerDetailStats = true;
                    this.countCreatedResponse++;
                });
            },
            getEmployeeOverviewStats() {
                let url = actions.EMPLOYEES_OVERVIEW_STATS;

                this.axiosGet(url).then(response => {

                    this.employeeOverviewStats = response.data;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.isActiveEmployeeOverviewStats = true;
                    this.countCreatedResponse++;
                });
            },



            getChecklistData() {
                let today = new Date();
                let todayDate = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                let nextYearDate = (today.getFullYear()+1)+'-'+(today.getMonth()+1)+'-'+today.getDate();

                let url = actions.DATATABLE_CHECKLISTS_DATA+'?filter_with_status=1&filter_with_type=1&per_page=5&page=1&search=&sortBy=deadline&orderBy=asc';

                this.axiosGet(url).then(response => {

                    this.checklistData = response.data.data;
                    this.checklistDataTotal = response.data.total > 99 ? '99+' : response.data.total;

                }).catch(({response}) => {

                }).finally(() => {
                    this.checklistPreloader = false;
                });
            },
            getBirthdayData() {
                let url = actions.CANDIDATES_ONBOARDING_BIRTHDAY;

                this.axiosGet(url).then(response => {

                    this.birthdayData = response.data.data;
                    this.birthdayDataTotal = response.data.total;

                }).catch(({response}) => {

                }).finally(() => {
                    
                });
            },
            getAnniversaryData() {
                let url = actions.CANDIDATES_ONBOARDING_ANNIVERSARY;

                this.axiosGet(url).then(response => {

                    this.anniversaryData = response.data.data;
                    this.anniversaryDataTotal = response.data.total;

                }).catch(({response}) => {

                }).finally(() => {
                    
                });
            },
            getAttendees(){
                // Display atendees of course/quiz/feedback
                    let selectedAtendees = {
                        status: 3,
                        job: null, // @todo: maxion array
                        id: 39,
                        tag: null, // @todo: maxion array
                        per_page: 5000
                    };

                    this.axiosGet('admin/app/attendees?status=3&id=[39,43,44]&per_page=5000', {
                        // params: selectedAtendees
                    }).then(response => {

                        this.atendeeOptions = response.data;
                        this.getGraduates();

                    }).catch(({response}) => {
                    }).finally(() => {
                    });
                
            },

            getGraduates() {
                // Display stats of finished vs unfinished forms by candidates
                let url = 'admin/app/form-graduates', reqData = {};
                console.log("user "+this.user.loggedInUser.id);

                let formId = 10;

                if(window.location.href.indexOf('maxionwheels.onboardio.pro') > -1){
                    if(this.user.loggedInUser.id == 17){
                        formId = 10;
                    } else if(this.user.loggedInUser.id == 19){
                        formId = 11;
                    } else if(this.user.loggedInUser.id == 20){
                        formId = 12;
                    }
                }

                if(window.location.href.indexOf('demo.localhost') > -1 || window.location.href.indexOf('sconto.onboardio.pro') > -1){
                    formId = 1;
                }                

                reqData.params = {
                    id: formId, // @todo: change to maxion form id
                };

                this.axiosGet(url, reqData).then(response => {

                    this.graduateOptions = response.data;

                    let allAttendees = this.atendeeOptions.data;
                    let allGraduates = this.graduateOptions.data;
                    let allGraduateIds = [];

                    allGraduates.forEach(function (attendee) {
                        allGraduateIds.push(attendee.id);
                    });

                    this.atendeeOptions.data = allAttendees.filter(function( attendee ) {
                        return !allGraduateIds.includes(attendee.id)// data.id != response.data[0].id && data.id !== response.data[1].id;
                    });

                    // @todo: toto pocita jako absolventy vsechni, kteri odpovedeli alespon na jednu otazku, mozna to tak neni dobre a je potreba vyuzit completed_by_candidate_id
                    let graduateOptionsUnique = this.graduateOptions.data.filter((value, index, self) =>
                      index === self.findIndex((g) => (
                        g.id === value.id
                      ))
                    );

                    this.graduateOptionsUnique.data = graduateOptionsUnique;
                    this.graduateOptionsUnique.total = graduateOptionsUnique.length;

                }).catch(({response}) => {

                }).finally(() => {
                    this.isActiveAtendeeStats = true;
                    this.getGraduateStats();

                    if(window.location.href.indexOf('demo.localhost') > -1 || window.location.href.indexOf('maxionwheels.onboardio.pro') > -1 || window.location.href.indexOf('sconto.onboardio.pro') > -1){
                        this.showForms = true;
                    }
                    
                });
            },

            getGraduateStats() {
                let totalCorrect = 0;
                let totalWrong = 0;
                if(this.graduateOptions.totalCorrectAnswers){
                    totalCorrect = this.graduateOptions.totalCorrectAnswers;
                }
                if(this.graduateOptions.totalWrongAnswers){
                    totalWrong = this.graduateOptions.totalWrongAnswers;
                }

                this.graduateStats = {
                      "labels": [
                        this.$t('wrong'),
                        this.$t('correct'),
                      ],
                      "dataSet": [
                        {
                          "borderWidth": 0,
                          "backgroundColor": [
                            "#bc335d",
                            "#56818B",
                          ],
                          "data": [
                            totalWrong,
                            totalCorrect,
                          ]
                        }
                      ],
                      "chartElement": [
                        {
                          "key": this.$t('wrong'),
                          "value": totalWrong,
                          "background_color": "background-color: #bc335d;",
                          "color": "color: #bc335d;"
                        },
                        {
                          "key": this.$t('correct'),
                          "value": totalCorrect,
                          "background_color": "background-color: #56818B;",
                          "color": "color: #56818B;"
                        },
                      ]
                };
            },




            /**
             * Footer
             * */
            showContacts() {
                $('.footer-contacts').fadeToggle();
            },
            showYear() {
                let currentYear = new Date().getFullYear();
                return currentYear;
            },
            openChat() {
                $('.crisp-client').fadeToggle();
                $crisp.push(["do", "chat:open"]);
            },





            getFilterValue(item) {
                this.value = item;
                this.isActiveStudentOverview = false;
                this.studentOverview();
            },
            defaultData() {
                let url = actions.DEFAULT_ACADEMIC_INFO;

                this.axiosGet(url).then(response => {

                    this.academydashboard.defaultData = response.data;
                    this.isActivedDefaultData = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            studentOverview() {

                let url = actions.STUDENT_OVERVIEW, reqData = {};

                reqData.params = {
                    key: this.value
                };

                this.axiosGet(url, reqData).then(response => {

                    this.academydashboard.studentOverview = response.data;
                    this.isActiveStudentOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            schoolOverview() {
                let url = actions.SCHOOL_OVERVIEW;

                this.axiosGet(url).then(response => {

                    this.academydashboard.schoolOverview = response.data;
                    this.isActiveSchoolOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            instructorStudentOverview() {

                let url = actions.INSTRUCTOR_STUDENT_OVERVIEW;

                this.axiosGet(url).then(response => {

                    this.academydashboard.instructorStudentOverview = response.data;
                    this.isActiveInstructorStudentOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            numberFormat(value) {
                return numberFormatter(value);
            },

            businessFilterValue(item) {

                this.businessFilter = item;
                this.isActiveBusinessOverview = false;
                this.businessOverview();

            },
            contactFilterValue(item) {

                this.contactFilter = item;
                this.isActiveContactOverview = false;
                this.contactOverview();

            },
            ecommerceDefaultInfo() {

                let url = actions.DEFAULT_INFO;
                this.axiosGet(url).then(response => {

                    this.e_commerceDashboard.defaultInfo = response.data;
                    this.isActivedDefaultiInfo = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            businessOverview() {

                let url = actions.BUSINESS_OVERVIEW, reqData = {};
                reqData.params = {
                    key: this.businessFilter
                };

                this.axiosGet(url, reqData).then(response => {

                    this.e_commerceDashboard.businessOverview = response.data;
                    this.isActiveBusinessOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            contactOverview() {

                let url = actions.CONTACT_OVERVIEW, reqData = {};

                reqData.params = {
                    key: this.contactFilter
                };

                this.axiosGet(url, reqData).then(response => {

                    this.e_commerceDashboard.contactOverview = response.data;
                    this.isActiveContactOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            teamOverview() {

                let url = actions.TEAM_OVERVIEW;

                this.axiosGet(url).then(response => {

                    this.e_commerceDashboard.teamOverview = response.data;
                    this.isActiveTeamOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },


            patientStatistics() {
                let url = actions.PATIENT_STATISTICS;

                this.axiosGet(url).then(response => {

                    this.hospital.patientStatistics = response.data;
                    this.isActivePatientStatistics = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });

            },

            getTimelineStateNames() {

                this.axiosGet('admin/app/timeline-states?status=2').then(response => {
                    if(response.data.length){
                        this.timelineStatesLists = response.data;
                    } else {
                        this.timelineStatesLists = response.data;
                    }
                });

            },
            generateCalendar(id, timeline_state, date, name, phone, job, status) {

                let language = 'cs';
                let subject = '';
                let urlAddress = '';
                let description = 'Telefon: '+phone+', pracovní pozice: '+this.getJobName(job);

                var getUrl = window.location;
                var baseUrl = getUrl .protocol + "//" + getUrl.host + "/";

                if(status == 'onboarding'){
                    subject = 'Nástup do zaměstnání - '+name;
                    urlAddress = baseUrl+'onboarding?profile='+id;
                } else {
                    subject = this.timelineStatesLists[timeline_state-1].value+' - '+name;
                    urlAddress = baseUrl+'hiring?profile='+id;
                }

                let begin = date;
                let stop = moment(date).add(1, 'hours');
                let location = '';

                let organizer = '';
                this.$ics.addEvent(language, subject, description, location, begin, stop, urlAddress, organizer);
                let fileName = subject;
                this.$ics.download(fileName);
                this.$ics.removeAllEvents();

            },

            currencyFormat(value) {
                return numberWithCurrencySymbol(value);
            }
        }
    }
</script>
